import React from 'react';
import { CModal, CModalBody, CModalHeader, CModalTitle } from '@coreui/react';

import ResubscribeForm from './ResubscribeForm';

import { OVERLAY_CLOSED } from '../actions/overlay';

import { OverlayDispatch } from '../contexts/overlay';

const ResubscribeOverlay = () => {
  const overlayDispatch = React.useContext(OverlayDispatch);

  const close = () => {
    overlayDispatch({ type: OVERLAY_CLOSED });
  };

  return (
    <CModal show={true} size="lg" onClose={close}>
      <CModalHeader closeButton>
        <CModalTitle>Select a plan</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <ResubscribeForm />
      </CModalBody>
    </CModal>
  );
};

export default ResubscribeOverlay;
